import React, { Component } from "react";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardHeader,
  Label,
  Button,
  Input,
  FormGroup,
} from "reactstrap";
import querystring from "query-string";
import Select from "react-select/async";

import "react-bootstrap-table/dist/react-bootstrap-table.min.css";

import DateRangePicker from "react-dates/lib/components/DateRangePicker";

import history from "@/api/history";
import reports from "@/api/reports";

import moment from "moment-timezone";

import TransactionsTable from "../Components/TransactionsTable";
import TableContainerWithLocation from "../Components/TableContainerWithLocation";
import { APP_CONST } from "../../store/dataStore";
import { handleError } from "@/util/errorHandler";

const defaultUserOption = { value: "", label: "ALL" };
class History extends Component {
  table = React.createRef();

  state = {
    dateFrom: moment().startOf("month"),
    dateTo: moment(),
    focusedInput: null,
    isError: true,

    userOption: null,
    userOptions: [],
    currencies: [],
    currency: "",
    transactionStatuses: [],
    transactionStatus: "",
  };

  handleInputChange = event => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({ [name]: value });
  };

  getUserOption(searchQuery) {
    return {
      value: searchQuery.user || defaultUserOption.value,
      label: searchQuery.user || defaultUserOption.label,
    };
  }

  getAccountsCurrenciesStatuses = () => {
    history
      .getAccountsCurrenciesStatuses()
      .then(({ transactionStatuses, currencies }) => {
        this.setState({
          transactionStatuses,
          currencies,
        });
      })
      .catch(error => handleError(new Error(error.response)));
  };

  searchAccount = async query => {
    try {
      const accounts = await history.searchAccount(query);
      const options = this.buildUserOptions(accounts);

      return options;
    } catch (error) {
      return [];
    }
  };

  componentDidMount() {
    const searchQuery = querystring.parse(this.props.location.search);

    this.setState({
      ...searchQuery,
      userOption: this.getUserOption(searchQuery),
      dateFrom: searchQuery.dateFrom
        ? moment(searchQuery.dateFrom, APP_CONST.DATE_FROM)
        : undefined,
      dateTo: searchQuery.dateTo
        ? moment(searchQuery.dateTo, APP_CONST.DATE_TO)
        : undefined,
    });

    this.getAccountsCurrenciesStatuses();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.search !== this.props.location.search) {
      const searchQuery = querystring.parse(this.props.location.search);
      searchQuery.userOption = this.getUserOption(searchQuery);

      const {
        dateFrom,
        dateTo,
        userOption,
        currency = "",
        transactionStatus = "",
      } = searchQuery;

      this.setState({
        dateFrom: dateFrom ? moment(dateFrom, APP_CONST.DATE_FROM) : undefined,
        dateTo: dateTo ? moment(dateTo, APP_CONST.DATE_TO) : undefined,
        userOption,
        currency,
        transactionStatus,
      });
    }
  }

  fetchHistory = (page = 0, size = 10, filter = "", sort = "") => {
    const {
      currency,
      user,
      dateFrom,
      dateTo,
      transactionStatus,
    } = querystring.parse(this.props.location.search);

    return history.getHistory(
      currency,
      user,
      dateFrom,
      dateTo,
      transactionStatus,
      page,
      size,
      filter,
      sort,
    );
  };

  handleSearchClick = () => {
    const { history, location } = this.props;

    const newQueryParams = {
      currency: this.state.currency,
      user: this.state.userOption.value,
      dateFrom:
        this.state.dateFrom && this.state.dateFrom.format(APP_CONST.DATE_FROM),
      dateTo: this.state.dateTo && this.state.dateTo.format(APP_CONST.DATE_TO),
      transactionStatus: this.state.transactionStatus,
    };

    const oldSearchQuery = querystring.parse(location.search);
    const newSearchQuery = querystring.stringify({
      ...oldSearchQuery,
      ...newQueryParams,
    });

    history.push({
      ...location,
      search: newSearchQuery,
    });

    setImmediate(() => {
      this.table.loadAndStoreData();
    });
  };

  handleUserChange = userOption => {
    this.setState({ userOption });
  };

  buildUserOptions(irohaAccounts) {
    const options = irohaAccounts.map(acc => ({
      value: acc,
      label: acc,
    }));

    return options;
  }

  render() {
    const {
      userOption,
      userOptions,
      currencies,
      currency,
      transactionStatuses,
      transactionStatus,
      dateFrom,
      dateTo,
    } = this.state;
    return (
      <div className="animated fadeIn">
        <Card>
          <CardHeader>History</CardHeader>
          <CardBody>
            <Row>
              <Col>
                <FormGroup row>
                  <Col md="3">
                    <Label htmlFor="currency">
                      <h6>
                        Currency
                        <span className="text-danger">*</span>:
                      </h6>
                    </Label>
                  </Col>
                  <Col
                    xs={{
                      size: 8,
                    }}
                    md="5">
                    <Input
                      type="select"
                      name="currency"
                      id="currency"
                      value={currency}
                      onChange={this.handleInputChange}>
                      <option value="">ALL</option>
                      {currencies.map(item => {
                        return (
                          <option value={item} key={item}>
                            {item}
                          </option>
                        );
                      })}
                    </Input>
                  </Col>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormGroup row>
                  <Col md="3">
                    <Label>
                      <h6>To Account:</h6>
                    </Label>
                  </Col>
                  <Col
                    xs={{
                      size: 8,
                    }}
                    md="5">
                    <Select
                      cacheOptions
                      value={userOption || userOptions[0]}
                      onChange={this.handleUserChange}
                      loadOptions={this.searchAccount}
                    />
                  </Col>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormGroup row>
                  <Col md="3">
                    <Label htmlFor="select">
                      <h6>Dates:</h6>
                    </Label>
                  </Col>
                  <Col
                    xs={{
                      size: 8,
                    }}
                    md="4">
                    <DateRangePicker
                      startDate={dateFrom}
                      startDateId="date_from"
                      endDate={dateTo}
                      endDateId="date_to"
                      onDatesChange={({ startDate, endDate }) =>
                        this.setState({ dateFrom: startDate, dateTo: endDate })
                      }
                      focusedInput={this.state.focusedInput}
                      onFocusChange={focusedInput =>
                        this.setState({ focusedInput })
                      }
                      showClearDates
                      showDefaultInputIcon
                      isOutsideRange={date =>
                        moment(date).isAfter(
                          moment.tz("Asia/Phnom_Penh").endOf("day"),
                        )
                      }
                      small
                      minimumNights={0}
                    />
                  </Col>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormGroup row>
                  <Col
                    xs={{
                      size: 8,
                    }}
                    md="3">
                    <Label htmlFor="transactionStatus">
                      <h6>Transaction Status:</h6>
                    </Label>
                  </Col>
                  <Col
                    xs={{
                      size: 8,
                    }}
                    md="4">
                    <Input
                      type="select"
                      name="transactionStatus"
                      id="transactionStatus"
                      value={transactionStatus}
                      onChange={this.handleInputChange}>
                      <option value="">ALL</option>
                      {transactionStatuses.map(status => {
                        return (
                          <option value={status} key={status}>
                            {status}
                          </option>
                        );
                      })}
                    </Input>
                  </Col>
                  <Col
                    lg={{
                      size: 3,
                      offset: 0,
                    }}
                    xs={{
                      size: 4,
                      offset: 0,
                    }}>
                    <Button
                      color="primary"
                      type="button"
                      onClick={this.handleSearchClick}>
                      Search
                    </Button>
                  </Col>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <TableContainerWithLocation
                  loadData={this.fetchHistory}
                  requestReport={({ ...args }) =>
                    reports.requestHistory({
                      ...args,
                      account: userOption.value,
                      status: transactionStatus,
                    })
                  }
                  wrappedComponentRef={innerComponent => {
                    // Forwarding ref to TableContainerWithLocation through 'withRouter' HOC
                    // This is the only way to forward ref with React Router 4
                    if (innerComponent) {
                      this.table = innerComponent;
                    }
                  }}>
                  <TransactionsTable
                    type={"outgoing"}
                    isAuditor={this.props.type === "auditor"}
                  />
                </TableContainerWithLocation>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    );
  }
}

export default History;
